<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/masterData/certificateTemplates/${inputs.id}`
            : `/masterData/certificateTemplates`
        "
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("accreditation_area") }}
              </label>
              <app-input
                id="inputs_accreditation_area_id"
                type="select"
                v-model="inputs.accreditation_area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
                v-if="!selectedUrl"
              />

              <app-input
                id="inputs_accreditation_area_id"
                type="select"
                v-model="inputs.accreditation_area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
                disabled
                v-if="selectedUrl"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("activity") }}
              </label>
              <app-input
                id="inputs_acc_act_id"
                type="select"
                v-model="inputs.acc_act_id"
                :list="accreditationActivityLists"
                :required="true"
                v-if="!selectedUrl"
              />
              <app-input
                id="inputs_acc_act_id"
                type="select"
                v-model="inputs.acc_act_id"
                :list="accreditationActivityLists"
                :required="true"
                disabled
                v-if="selectedUrl"
              />
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-0">Activo</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_active"
                :list="isActive"
              />
            </div>
          </div>

          <div class="col-md-12">
            <label class="mb-0">Logos</label>
            <div class="form-check">
              <input
                type="checkbox"
                id="inputs_iaac"
                v-model="inputs.logo_iaac"
              />
              <label class="form-check-label ml-2" for="inputs_iaac"
                >IAAC</label
              >
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                id="inputs_apac"
                v-model="inputs.logo_apac"
              />
              <label class="form-check-label ml-2" for="inputs_apac"
                >APAC</label
              >
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                id="inputs_ilac"
                v-model="inputs.logo_ilac"
              />
              <label class="form-check-label ml-2" for="inputs_ilac"
                >ILAC</label
              >
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                id="inputs_iaf"
                v-model="inputs.logo_iaf"
              />
              <label class="form-check-label ml-2" for="inputs_iaf">IAF</label>
            </div>
          </div>

          <!-- <div class="col-md-12 mt-2">
            <label class="mb-0">Observaciones</label>
            <div class="form-check">
              <input
                type="checkbox"
                id="inputs_sae"
                v-model="inputs.logo_sae"
              />
            </div>
          </div> -->

          <div class="col-12 mt-2">
            <div class="form-group">
              <label class="mb-1">Contenido del certificado</label>
              <quill-editor v-model="inputs.top_text" :options="editorOption" />
            </div>
          </div>
          <!-- <div class="col-12">
            <div class="form-group">
              <label class="mb-1">Contenido medio</label>
              <quill-editor
                v-model="inputs.middle_text"
                :options="editorOption"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="mb-1">Contenido inferior</label>
              <quill-editor
                v-model="inputs.bottom_text"
                :options="editorOption"
              />
            </div>
          </div> -->
          <div class="col-12 space">
            <div class="form-group">
              <label class="mb-1">
                Firmado <span class="color-req">*</span>
              </label>
              <quill-editor v-model="inputs.signed" :options="editorOption" />
            </div>
          </div>
          <!-- <div class="col-12 space">
            <div class="form-group">
              <label class="mb-1">Observación</label>
              <quill-editor v-model="inputs.footer1" :options="editorOption" />
            </div>
          </div> -->
          <!-- <div class="col-12">
            <div class="form-group">
              <label class="mb-1">Texto inferior 2</label>
              <quill-editor v-model="inputs.footer2" :options="editorOption" />
            </div>
          </div> -->
          <div class="col-12 space">
            <div class="form-group">
              <label class="mb-1">
                Código de seguridad <span class="color-req">*</span>
              </label>
              <quill-editor
                v-model="inputs.certificate_version"
                value=""
                :options="editorOption"
              />
            </div>
          </div>
          <div class="col-12 space">
            <div class="form-group">
              <label class="mb-1">
                Formato <span class="color-req">*</span>
              </label>
              <app-input
                type="text"
                v-model="inputs.format_code"
                placeholder="Ingresar texto.."
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { quillEditor },
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {
        is_active: 1,
        signed: null,
        certificate_version: null,
      },
      modalId: "modal-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.loaded = true;
    }
  },
  methods: {
    submit() {
      if (
        this.inputs.signed != null &&
        this.inputs.certificate_version != null
      ) {
        this.save(this.inputs);
      } else {
        this.$toastr.e(this.$t("Todos los campos con un (*) son obligatorios."));
      }
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = {
        ...response.data,
        accreditation_area_id:
          response.data.accreditation_activity.accreditation_area_id,
      };
      this.onChangeAccreditationArea();
      this.preloader = false;
      this.loaded = true;
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.accreditation_area_id;
        }),
      ];
    },
  },
};
</script>
<style>
.color-req {
  color: red;
}

.space {
  margin-top: 100px;
}
</style>
